export default (clientHttp, apiVersion) => ({
  read(slug) {
    if (slug) {
      return clientHttp.get(`${apiVersion}/user/houses/${slug}`)
    }

    return clientHttp.get(`${apiVersion}/user/houses`)
  },
})
